import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export
} from 'devextreme-react/data-grid';
import Request from "../../../components/api/Request";
import CustomStore from 'devextreme/data/custom_store';     
import * as AppActions from '../../../actions/AppActions'; 
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';   
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate,hasRole } from "../../../utils/Utils";
import './RoleGroup.scss'; 
import RolGroupDetail from './RoleGroupDetail';

const RoleGroup = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            getKayit: hasRole("tanimlar|roleTanim|getKayit"),    
            listele: hasRole("tanimlar|roleTanim|listele"),  
            ekle: hasRole("tanimlar|roleTanim|ekle"),  
            degistir: hasRole("tanimlar|roleTanim|degistir"),  
            sil: hasRole("tanimlar|roleTanim|sil"),   
        });

    const listeBasligi = "Teşvik Rapor Fark";
    const [store, setStore] = useState(null);
    const [roleData, setRoleData] = useState({ popupState: false, data: [] });

    let dataGrid = null;

    useEffect(() => {
        setStore(getStore());
    }, [])


    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) { 
                const request = new Request("/roleGroup/getKayitList", "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    const yenile = () => {

        setStore(getStore());
    }

    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: (e) => { return  formYetki.ekle },
            options: {
                icon: 'add',
                onClick: () => {
                    addDetay(null);
                }
            }
        });
    }

    function hideRoleDataPopup() {
        setRoleData({ popupState: false, data: {} })
        yenile();
    }
    

    function addDetay(data) {
        setRoleData({ popupState: true, data: null })
    }
    function editDetay(data) {
        setRoleData({ popupState: true, data: data })
    }
    function deleteDetay(data) {
        const request = new Request("/roleGroup/deleteKayit/" + data.id, "DELETE");

        return request.run()
            .then(response => {
                if (response.data) {
                    yenile();
                }  
            });
    }
    return (
        <div >
            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>

                </div>
            </div>
            <DataGrid
                className="roleGroupGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                onToolbarPreparing={onToolbarPreparingDetay}
            //selection={{ mode: 'single', deferred: true }} 
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />

                <Column type="buttons" caption={'İşlem'}
                    buttons={[  
                        {
                            hint: 'Düzenle', icon: 'edit', 
                            visible: () => { return formYetki.degistir },		
                            onClick: (e) => { editDetay(e.row.data); }
                        },
                        {
                            hint: 'Sil', icon: 'remove',
                            visible: () => { return formYetki.sil },
                            onClick: (e) => { deleteDetay(e.row.data); }
                        },
                    ]}
                />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'name'} width={90} caption={'Adı'} dataType="string" visible={true} />
               
            </DataGrid>

            <Popup
                visible={roleData.popupState}
                onHiding={hideRoleDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Firma Detay Bilgi"
                width={750}
                height={675}
            >
                <div>
                    {roleData.popupState ? <RolGroupDetail data={roleData.data} hide={hideRoleDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideRoleDataPopup}
                    />
                </div>
            </Popup>

        </div>
    )
}

export default RoleGroup;
